import type { Traducao } from '../tipos';

/** Textos de `maquinas`. Preenchido pela tradução da área — ver ../README.md. */
export const maquinas: Traducao = {
  pt: {
    lista: {
      titulo: 'Máquinas',
      subtitulo: 'Gerencie o cadastro de máquinas e equipamentos',
      novaMaquina: 'Nova Máquina',
      filtro: {
        busca: 'Busca',
        buscaPlaceholder: 'Equipamento, TAG, Item...',
        tipoPlaceholder: 'Filtrar por tipo...',
        areaPlaceholder: 'Filtrar por área...',
      },
      carregando: 'Carregando máquinas...',
      vazio: {
        titulo: 'Nenhuma máquina encontrada',
        comFiltro: 'Tente ajustar os filtros.',
        semFiltro: 'Clique em "Nova Máquina" para cadastrar.',
      },
      coluna: {
        areaLocal: 'Área / Local',
        equipamento: 'Equipamento',
        tag: 'TAG',
        apreciacoes: 'Apreciações',
      },
      itemPrefixo: 'Item: {{item}}',
      acao: {
        abrir: 'Abrir máquina',
        editar: 'Editar máquina',
        remover: 'Remover máquina',
      },
      paginacao: {
        resumo: 'Página {{pagina}} de {{totalPaginas}} · {{total}} itens',
        anterior: 'Anterior',
        proxima: 'Próxima',
      },
      remover: {
        titulo: 'Remover Máquina',
        confirmacao: 'Tem certeza que deseja remover "{{nome}}"?',
        erro: 'Erro ao remover máquina.',
      },
      erro: {
        carregar: 'Não foi possível carregar as máquinas.',
        servidor: 'Não foi possível falar com o servidor. A lista pode estar desatualizada.',
        offline: 'Sem conexão. A lista é a última carregada.',
      },
    },
    detalhe: {
      voltar: 'Voltar para máquinas',
      carregando: 'Carregando máquina...',
      semNome: 'Máquina sem nome',
      dados: {
        titulo: 'Dados do equipamento',
        levantamento: 'Levantamento',
        previsaoLevantamento: 'Previsão de levantamento',
        semValor: '—',
      },
      apreciacoes: {
        titulo: 'Apreciações desta máquina',
        vazio: 'Nenhuma apreciação vinculada a esta máquina.',
        abrir: 'Abrir apreciação',
        revisao: 'Rev. {{revisao}}',
      },
    },
    form: {
      tituloNovo: 'Nova Máquina',
      subtituloNovo: 'Cadastre uma nova máquina ou equipamento',
      tituloEditar: 'Editar Máquina',
      salvarNova: 'Salvar Máquina',
      salvarAlteracoes: 'Salvar Alterações',
      secao: {
        identificacao: 'Identificação',
        localizacao: 'Localização',
        referencias: 'Referências e Números',
        observacoes: 'Observações',
      },
      campo: {
        equipamento: 'Equipamento / Nome da Máquina',
        equipamentoPlaceholder: 'Ex.: MISTURADOR ROTERID N° 1, PRENSA HIDRÁULICA 50T...',
        tipoPlaceholder: 'Ex.: MISTURADOR, PRENSA, TORNO...',
        tag: 'TAG',
        tagPlaceholder: 'Ex.: TAG-001',
        item: 'Item',
        itemPlaceholder: 'Ex.: 032',
        idItem: 'ID do Item',
        idItemPlaceholder: 'Ex.: EQ-20-032',
        statusPlaceholder: 'Selecione o status...',
        funcionario: 'Responsável / Funcionário',
        funcionarioPlaceholder: 'Nome do responsável',
        template: 'Template NR-12',
        templatePlaceholder: 'Ex.: NR-12 Prensas',
        areaPlaceholder: 'Ex.: 20-FUNDIÇÃO',
        localPlaceholder: 'Ex.: 03-FUNDIÇÃO DE PEÇAS',
        numeroAprPraxis: 'N° APR no PRAXIS',
        numeroAprPraxisPlaceholder: 'Ex.: APR-2024-001',
        numeroAmt: 'Número AMT',
        numeroAmtPlaceholder: 'Ex.: AMT-001',
        refSap: 'Ref. SAP',
        refSapPlaceholder: 'Ex.: SAP-00001',
        refSismanaAntigo: 'Ref. SISMANA (Antigo)',
        refSismanaAntigoPlaceholder: 'Referência anterior',
        refSismanaNovo: 'Ref. SISMANA (Novo)',
        refSismanaNovoPlaceholder: 'Referência atual',
        observacaoPlaceholder: 'Informações adicionais sobre a máquina...',
      },
      // Rótulo do `<option>`; o `value` continua sendo o valor que vai para a API.
      status: {
        levantar: 'LEVANTAR',
        levantado: 'LEVANTADO',
        emAnalise: 'EM ANÁLISE',
        aprovado: 'APROVADO',
        arquivado: 'ARQUIVADO',
      },
      erro: {
        equipamentoObrigatorio: 'Nome do equipamento é obrigatório',
        criar: 'Erro ao cadastrar máquina',
        criarTentarNovamente: 'Erro ao cadastrar máquina. Tente novamente.',
        salvar: 'Erro ao salvar máquina',
        salvarTentarNovamente: 'Erro ao salvar máquina. Tente novamente.',
        naoEncontrada: 'Máquina não encontrada',
        carregar: 'Erro ao carregar dados da máquina.',
      },
    },
  },
  en: {
    lista: {
      titulo: 'Machines',
      subtitulo: 'Manage the machine and equipment registry',
      novaMaquina: 'New Machine',
      filtro: {
        busca: 'Search',
        buscaPlaceholder: 'Equipment, TAG, Item...',
        tipoPlaceholder: 'Filter by type...',
        areaPlaceholder: 'Filter by area...',
      },
      carregando: 'Loading machines...',
      vazio: {
        titulo: 'No machines found',
        comFiltro: 'Try adjusting the filters.',
        semFiltro: 'Click "New Machine" to register one.',
      },
      coluna: {
        areaLocal: 'Area / Location',
        equipamento: 'Equipment',
        tag: 'TAG',
        apreciacoes: 'Risk Assessments',
      },
      itemPrefixo: 'Item: {{item}}',
      acao: {
        abrir: 'Open machine',
        editar: 'Edit machine',
        remover: 'Remove machine',
      },
      paginacao: {
        resumo: 'Page {{pagina}} of {{totalPaginas}} · {{total}} items',
        anterior: 'Previous',
        proxima: 'Next',
      },
      remover: {
        titulo: 'Remove Machine',
        confirmacao: 'Are you sure you want to remove "{{nome}}"?',
        erro: 'Could not remove the machine.',
      },
      erro: {
        carregar: 'Could not load the machines.',
        servidor: 'Could not reach the server. The list may be out of date.',
        offline: 'No connection. This is the last list loaded.',
      },
    },
    detalhe: {
      voltar: 'Back to machines',
      carregando: 'Loading machine...',
      semNome: 'Unnamed machine',
      dados: {
        titulo: 'Equipment data',
        levantamento: 'Survey',
        previsaoLevantamento: 'Planned survey',
        semValor: '—',
      },
      apreciacoes: {
        titulo: 'Risk assessments for this machine',
        vazio: 'No risk assessment linked to this machine.',
        abrir: 'Open risk assessment',
        revisao: 'Rev. {{revisao}}',
      },
    },
    form: {
      tituloNovo: 'New Machine',
      subtituloNovo: 'Register a new machine or piece of equipment',
      tituloEditar: 'Edit Machine',
      salvarNova: 'Save Machine',
      salvarAlteracoes: 'Save Changes',
      secao: {
        identificacao: 'Identification',
        localizacao: 'Location',
        referencias: 'References and Numbers',
        observacoes: 'Notes',
      },
      campo: {
        equipamento: 'Equipment / Machine Name',
        equipamentoPlaceholder: 'e.g.: ROTERID MIXER No. 1, 50T HYDRAULIC PRESS...',
        tipoPlaceholder: 'e.g.: MIXER, PRESS, LATHE...',
        tag: 'TAG',
        tagPlaceholder: 'e.g.: TAG-001',
        item: 'Item',
        itemPlaceholder: 'e.g.: 032',
        idItem: 'Item ID',
        idItemPlaceholder: 'e.g.: EQ-20-032',
        statusPlaceholder: 'Select the status...',
        funcionario: 'Owner / Employee',
        funcionarioPlaceholder: "Owner's name",
        template: 'NR-12 Template',
        templatePlaceholder: 'e.g.: NR-12 Presses',
        areaPlaceholder: 'e.g.: 20-FOUNDRY',
        localPlaceholder: 'e.g.: 03-PARTS FOUNDRY',
        numeroAprPraxis: 'APR No. in PRAXIS',
        numeroAprPraxisPlaceholder: 'e.g.: APR-2024-001',
        numeroAmt: 'AMT Number',
        numeroAmtPlaceholder: 'e.g.: AMT-001',
        refSap: 'SAP Ref.',
        refSapPlaceholder: 'e.g.: SAP-00001',
        refSismanaAntigo: 'SISMANA Ref. (Old)',
        refSismanaAntigoPlaceholder: 'Previous reference',
        refSismanaNovo: 'SISMANA Ref. (New)',
        refSismanaNovoPlaceholder: 'Current reference',
        observacaoPlaceholder: 'Additional information about the machine...',
      },
      status: {
        levantar: 'TO SURVEY',
        levantado: 'SURVEYED',
        emAnalise: 'UNDER REVIEW',
        aprovado: 'APPROVED',
        arquivado: 'ARCHIVED',
      },
      erro: {
        equipamentoObrigatorio: 'Equipment name is required',
        criar: 'Could not register the machine',
        criarTentarNovamente: 'Could not register the machine. Please try again.',
        salvar: 'Could not save the machine',
        salvarTentarNovamente: 'Could not save the machine. Please try again.',
        naoEncontrada: 'Machine not found',
        carregar: 'Could not load the machine data.',
      },
    },
  },
};
